<template>
    <PpWagerEditorComponent />

    <Popper
        :show="popperVisible"
        :arrow="true"
        placement="top"
        class="ds-tooltip"
        :locked="true"
        offset-distance="-2"
        z-index="300"
    >
        <div class="pp-ticket-check__button-wrapper">
            <PpConfirmButton @click="handleClick" :is-disabled="isDisabled" data-test="button-check-ticket">
                Zkontrolovat sázku
            </PpConfirmButton>
        </div>
        <template #content>
            <div class="ds-tooltip__content pp-confirm-button__popper" role="tooltip">
                <span v-html="errorMessage"></span>
            </div>
        </template>
    </Popper>
    <PpTicketCheckResults v-if="ticketCheckResult" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import Popper from "vue3-popper";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { getLotteryConfig } from "@sazka/lotteries/js/utils/lottery-configs/get-lottery-config";
import { usePpWagerConfiguration } from "./composables/use-wager-configuration";
import { usePpTicketCheck } from "./composables/use-ticket-check";
import PpConfirmButton from "./components/pp-confirm-button.vue";
import PpTicketCheckResults from "./components/ticket-check/pp-ticket-check-results.vue";
import PpWagerEditorComponent from "./components/pp-wager-editor-component.vue";
import { usePpWagerValidator } from "./composables/use-wager-validator";

const props = defineProps<{
    lottery: string;
}>();

const lottery = computed(() => LotteryParser.parseLotteryName(props.lottery));

const { setTicketCheck, ticketCheckResult } = usePpTicketCheck();
setTicketCheck(true);

onMounted(() => {
    // CLS fix
    const root = document.getElementById("pp-ticket-check");
    root.classList.add("loaded");
});

const config = getLotteryConfig(lottery.value);
usePpWagerConfiguration().configure(config);

const { isTicketCheckValid, errorMessage } = usePpWagerValidator();

const isDisabled = computed(() => !isTicketCheckValid.value);
const showPopper = ref(false);
const popperVisible = computed(() => showPopper.value && isDisabled.value);

const handleClick = async () => {
    if (isDisabled.value) {
        showPopper.value = true;
        setTimeout(() => {
            showPopper.value = false;
        }, 3000);
    } else {
        await usePpTicketCheck().getTicketCheckResult();
    }
};
</script>
